// 聯絡人管理服務
import { db } from '../cloudsql';

export interface Contact {
  id: string;
  customer_id: string;
  company?: string;
  name: string;
  email?: string;
  phone?: string;
  position?: string;
  status?: 'active' | 'inactive';
  is_contract_contact?: boolean;
  is_finance_contact?: boolean;
  can_login?: boolean;
  created_at: string;
  updated_at: string;
}

export class ContactsService {
  // 取得所有聯絡人
  async getAll(orderBy?: { field: string; direction: 'asc' | 'desc' }[]): Promise<Contact[]> {
    return db.query<Contact>('contacts', {
      orderBy: orderBy || [{ field: 'name', direction: 'asc' }]
    });
  }

  // 依客戶 ID 取得聯絡人
  async getByCustomerId(customerId: string): Promise<Contact[]> {
    return db.query<Contact>('contacts', {
      where: { customer_id: customerId },
      orderBy: [{ field: 'name', direction: 'asc' }]
    });
  }

  // 取得活躍聯絡人
  async getActiveContacts(customerId?: string): Promise<Contact[]> {
    const where: Record<string, unknown> = { status: 'active' };
    if (customerId) {
      where.customer_id = customerId;
    }
    return db.query<Contact>('contacts', {
      where,
      orderBy: [{ field: 'name', direction: 'asc' }]
    });
  }

  // 依 ID 取得聯絡人
  async getById(id: string): Promise<Contact | null> {
    return db.getById<Contact>('contacts', id);
  }

  // 建立聯絡人
  async create(data: Omit<Contact, 'id' | 'created_at' | 'updated_at'>): Promise<Contact> {
    return db.create<Contact>('contacts', { status: 'active', ...data });
  }

  // 更新聯絡人
  async update(id: string, data: Partial<Contact>): Promise<Contact> {
    return db.update<Contact>('contacts', id, data);
  }

  // 設為在職／離職（離職會關閉登入並從列表隱藏，紀錄保留給歷史報價）
  async setStatus(id: string, status: 'active' | 'inactive'): Promise<Contact> {
    const data: Partial<Contact> = { status };
    if (status === 'inactive') {
      data.can_login = false;
    }
    return db.update<Contact>('contacts', id, data);
  }

  // 實體刪除聯絡人
  async delete(id: string): Promise<void> {
    return db.delete('contacts', id);
  }

  // 批次取得聯絡人（依 ID 陣列）
  async getByIds(ids: string[]): Promise<Contact[]> {
    if (ids.length === 0) return [];
    return db.query<Contact>('contacts', {
      where: { id: ids }
    });
  }
}

// 匯出單例
export const contactsService = new ContactsService();


